import { DisplayMoney } from '@tock/money';
import { core } from '@tock/coretypes';
import DisplayPercentage from '@tock/shared/components/number/DisplayPercentage';
import React from 'react';
import ReceiptCallout from 'components/business/receipts/ReceiptCallout';

interface TockFeeCalloutProps {
  businessName?: string;
  tockFee: core.ITockFee;
}
export const TockFeeCallout: React.FunctionComponent<TockFeeCalloutProps> = ({
  businessName,
  tockFee,
}) => {
  let body: React.ReactNode;
  if (tockFee.percent && tockFee.perPersonCents) {
    body = (
      <>
        <span>
          Tock will charge {businessName ?? 'this business'} a commission of{' '}
          <DisplayPercentage value={tockFee.percent / 100} /> of the total amount charged for this
          order plus <DisplayMoney amount={tockFee.perPersonCents} /> per ticket.
        </span>
      </>
    );
  } else if (tockFee.percent) {
    body = (
      <>
        Tock will charge {businessName ?? 'this business'} a commission of{' '}
        <DisplayPercentage value={tockFee.percent / 100} /> of the total amount charged for this
        order.
      </>
    );
  } else if (tockFee.perPersonCents) {
    body = (
      <>
        Tock will charge {businessName ?? 'this business'} a commission of{' '}
        <DisplayMoney amount={tockFee.perPersonCents} /> per ticket for this order.
      </>
    );
  } else {
    // we should never get here -- tockFee was set but completely empty. Bail.
    return null;
  }

  return <ReceiptCallout data-testid="receipt-tock-fee">{body}</ReceiptCallout>;
};
